export default __webpack_public_path__ + "static/reportssvg-76e46a344c7be37aa5d90a3a3d522e76.svg";